/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import * as AppPropTypes from '../../lib/PropTypes';
import Label from '../partials/Label';

import styles from '../../../styles/fields/form-group.module.scss';

const propTypes = {
    name: PropTypes.string,
    label: AppPropTypes.label,
    children: PropTypes.node,
    errors: AppPropTypes.formErrors,
    help: AppPropTypes.label,
    className: PropTypes.string,
    labelClassName: PropTypes.string,
    showLabel: PropTypes.bool,
};

const defaultProps = {
    name: null,
    label: null,
    children: null,
    errors: null,
    help: null,
    className: null,
    labelClassName: null,
    showLabel: false
};

const FormGroup = ({ name, label, children, errors, help, className, labelClassName, showLabel }) => (
    <div
        className={classNames([
            styles.container,
            {
                [styles.hasErrors]: errors !== null && errors.length > 0,
                [styles.isLabelHidden]: !showLabel,
                [className]: className !== null,
            },
        ])}
    >
        {label !== null ? (
            <label
                htmlFor={name}
                className={classNames([
                    styles.label,
                    {
                        [labelClassName]: labelClassName !== null,
                    },
                ])}
            >
                <Label>{label}</Label>
            </label>
        ) : null}
        {children}
        {help !== null ? (
            <div className={styles.help}>
                <Label>{help}</Label>
            </div>
        ) : null}
        {errors !== null && errors.length > 0 ? (
            <ul className={styles.errors}>
                {errors.map((err) => (
                    <li key={`${err}`} className={styles.error}>
                        {err}
                    </li>
                ))}
            </ul>
        ) : null}
    </div>
);

FormGroup.propTypes = propTypes;
FormGroup.defaultProps = defaultProps;

export default FormGroup;
